import React, { useState } from 'react';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import styled from 'styled-components';

import { CLARET } from '../constants/colors';

const url =
  'https://gmail.us20.list-manage.com/subscribe/post?u=16ddea6ac5ba4d0583661d55b&amp;id=185ef7e081';

const FormWrapper = styled.div`
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  margin: 2rem -3rem;
  padding: 1.2rem 3rem;

  @media (max-width: 100px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

const Error = styled.div`
  color: ${CLARET};
  font-size: 0.75rem;
  margin-bottom: 1.5em;
`;

const Input = styled.input`
  border: none;
  padding: 0.625em 1em;
  font-size: 0.875rem;
  width: 13rem;
`;

const Button = styled.button`
  font-family: Roboto, sans-serif;
  background: ${CLARET};
  padding: 0.625em 1em;
  font-size: 0.875rem;
  color: white;
  border: none;
  font-weight: 700;
  text-transform: uppercase;

  &:disabled {
    opacity: 0.7;
  }
`;

const Header = styled.h2`
  margin: 0;
`;

const Paragraph = styled.p`
  margin: 0.5em 0 0;
`;

const InputWrapper = styled.div`
  margin-top: 1.5em;
`;

const NewsletterForm = () => {
  const [input, setInput] = useState('');

  const handleSubmit = submit => e => {
    e.preventDefault();
    submit({ EMAIL: input });
  };

  return (
    <FormWrapper>
      <MailchimpSubscribe
        url={url}
        render={({ subscribe, status, message }) => (
          <form onSubmit={handleSubmit(subscribe)}>
            {status === 'success' ? (
              <>
                <Header>Zapisałeś się do Newslettera!</Header>
                <Paragraph>
                  Od teraz będziesz dostawał powiadomienia o nowych postach.
                </Paragraph>
              </>
            ) : (
              <>
                <Header>Dołącz do Newslettera</Header>
                <Paragraph>
                  A będziesz na bieżąco ze wszystkimi postami na moim blogu.
                </Paragraph>
                {status === 'error' && (
                  <Error dangerouslySetInnerHTML={{ __html: message }} />
                )}
                <InputWrapper>
                  <Input
                    type="email"
                    value={input}
                    placeholder="Adres e-mail"
                    onChange={e => setInput(e.target.value)}
                  />
                  <Button disabled={status === 'sending'} type="submit">
                    ZAPISZ SIĘ
                  </Button>
                </InputWrapper>
              </>
            )}
          </form>
        )}
      />
    </FormWrapper>
  );
};

export default NewsletterForm;
